import { styled } from "@mui/material/styles";
import { Fab } from "@mui/material";
import { useNavigationContext } from "../../context/NavigationContext";
import refresh from 'assets/img/bottomNav/refresh.svg';
import tik from 'assets/img/bottomNav/tik.png';
import disableNfc from 'assets/img/bottomNav/scan_inactive.svg'
const StyledFab = styled(Fab)({
    position: 'absolute',
    zIndex: 1,
    top: -30,
    left: 0,
    right: 0,
    margin: '0 auto',
});
export default function ScanButton(props) {
    const { navigationClick, isActive, item } = props;
    const { navStatus, setNavStatus,nfcError, setNfcError,scanButton, setScanButton,nfcNotSupported } = useNavigationContext();
    const scanHandler = (event) => {
        let isSuccess = isActive && navStatus;
        // is success go to home and no need to call scan again
        if (!isSuccess)
            window?.ReactNativeWebView?.postMessage('scan');
        window?.ReactNativeWebView?.postMessage('startupcheck');
        setScanButton(!scanButton);
        setNfcError(false);
        setNavStatus(false);
        navigationClick(event, item, isSuccess);
    };

    return (
        <StyledFab disabled={nfcNotSupported&&isActive} onClick={scanHandler}
            className={isActive &&nfcNotSupported?'nfcNotSupport':isActive ? 'scan_active' : 'scan scanBtn'}>
            <div className={isActive && navStatus ? 'success_nav' :
                isActive && nfcError ? 'error_nav' :
                    isActive && !nfcNotSupported ? 'scan_in_active' : 'scan_in'}>
                {isActive &&nfcNotSupported?
                    <img style={{ minWidth: '24px',opacity:'0.5' }} src={disableNfc} alt='' />
                    : nfcError && isActive ? (
                    <img style={{ width: '20px' }} src={refresh} alt='' />
                ) : navStatus && isActive ? (
                    <img style={{ width: '25px' }} src={tik} alt='' />
                ) : (
                    <img style={{ minWidth: '24px' }} src={isActive ? item.activeImgSrc : item.imgSrc} alt='' />
                )}
            </div>
        </StyledFab>
    );
}